import { FC } from 'react'
import * as cn from 'classnames'
import * as styles from 'components/features/pfm/Spinner/Spinner.styl'
import Icon from 'components/atoms/Icon'

type SpinnerProps = {
  size?: 'normal' | 'medium' | 'large' | 'middle'
}

const Spinner: FC<SpinnerProps> = ({ size }) => {
  const className = cn(styles.spinner, {
    [styles.medium]: size === 'medium',
    [styles.large]: size === 'large',
    [styles.middle]: size === 'middle',
  })

  return (
    <div className={ className }>
      <Icon kind='spinner-light' />
    </div>
  )
}

Spinner.defaultProps = {
  size: 'normal',
}

export default Spinner
